/* Daymint · oc.js (FOUNDATION). Small shared runtime, no dependencies. Loaded with `defer` from oc-head.
   API (theme/CONTRACT.md §6): window.OC = { cfg, ready, on, emit, money, fmt, cart, dialog, lock, unlock,
   a11y, track, sticky, scroll, reducedMotion }. Events (on document, bubbling CustomEvents):
   oc:cart-updated, oc:cart-added, oc:cart-error, oc:dialog-open, oc:dialog-close, oc:header-scrolled,
   and (emitted by COMMERCE's oc-offer.js) oc:variant-change, oc:mode-change.
   Inline scripts that run before this file can queue work: (window.OCQ = window.OCQ || []).push(fn). */
(function () {
  'use strict';
  if (window.OC && window.OC.version) return;

  var d = document;
  var de = d.documentElement;
  var CFG = window.OC_CFG || {};
  var I18N = CFG.i18n || {};
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function reducedMotion() { return !!(mqReduce && mqReduce.matches); }
  function $(sel, root) { return (root || d).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }

  /* ---------- events ---------- */
  function emit(name, detail, target) {
    var ev;
    try { ev = new CustomEvent(name, { bubbles: true, detail: detail || {} }); }
    catch (e) { ev = d.createEvent('CustomEvent'); ev.initCustomEvent(name, true, false, detail || {}); }
    (target || d).dispatchEvent(ev);
    return ev;
  }
  function on(name, fn, target) {
    var t = target || d;
    t.addEventListener(name, fn);
    return function () { t.removeEventListener(name, fn); };
  }

  /* ---------- money and tokens ---------- */
  function delimit(num, dec, thousands, decimal) {
    var n = (Number(num) / 100).toFixed(dec);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
  }
  /** cents (integer) → string in the shop's money format, e.g. 7499 → "$74.99" */
  function money(cents, format) {
    if (cents === null || cents === undefined || isNaN(cents)) return '';
    var f = format || CFG.moneyFormat || '${{amount}}';
    var c = Math.round(Number(cents));
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return delimit(c, 2, ',', '.');
        case 'amount_no_decimals': return delimit(c, 0, ',', '.');
        case 'amount_with_comma_separator': return delimit(c, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(c, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delimit(c, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return delimit(c, 0, ' ', ',');
        case 'amount_with_space_separator': return delimit(c, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return delimit(c, 2, ' ', '.');
        default: return delimit(c, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  /** Replace %name% tokens; returns null when a token has no value (callers then hide the element). */
  function fmt(template, tokens) {
    var missing = false;
    var out = String(template == null ? '' : template).replace(/%([a-z0-9_]+)%/g, function (m, k) {
      var v = tokens ? tokens[k] : undefined;
      if (v === undefined || v === null || v === '') { missing = true; return ''; }
      return String(v);
    });
    return missing ? null : out;
  }

  /* ---------- scroll lock (shares Horizon's html[scroll-lock] attribute) ---------- */
  var locks = 0;
  function lock() { locks += 1; de.setAttribute('scroll-lock', ''); }
  function unlock() { locks = Math.max(0, locks - 1); if (!locks) de.removeAttribute('scroll-lock'); }

  /* ---------- cart (Shopify AJAX API) ---------- */
  var root = (CFG.root || '/').replace(/\/?$/, '/');
  function request(path, body) {
    var opts = { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(root + path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var err = new Error((j && (j.description || j.message)) || I18N.cartError || 'Cart error');
          err.status = r.status; err.data = j; throw err;
        }
        return j;
      });
    });
  }
  function cartLabel(n) {
    if (!n) return I18N.cartEmpty || 'Cart, empty';
    if (n === 1) return I18N.cartOne || 'Cart, 1 item';
    return (I18N.cartMany || 'Cart, %cart_count% items').replace('%cart_count%', n);
  }
  function setCount(n) {
    n = Number(n) || 0;
    cart.count = n;
    $$('[data-oc-cart-count]').forEach(function (el) { el.textContent = String(n); el.hidden = n < 1; });
    $$('[data-oc-cart-link]').forEach(function (a) { a.setAttribute('aria-label', cartLabel(n)); });
  }
  function publish(c, source) {
    setCount(c.item_count);
    emit('oc:cart-updated', { cart: c, count: c.item_count, source: source || 'oc' });
    return c;
  }
  function fail(e, source) { emit('oc:cart-error', { error: e, message: e.message, source: source }); throw e; }
  var cart = {
    count: Number(CFG.cartCount) || 0,
    /** GET /cart.js */
    get: function () { return request('cart.js').then(function (c) { return publish(c, 'get'); }); },
    /** POST /cart/add.js. items: {id, quantity, selling_plan?, properties?} or an array of them.
        Omit selling_plan (or pass null/'') for a one-time line. Resolves {added, cart}. */
    add: function (items) {
      var list = (Array.isArray(items) ? items : [items]).map(function (it) {
        var o = { id: Number(it.id), quantity: Number(it.quantity) || 1 };
        if (it.selling_plan) o.selling_plan = Number(it.selling_plan);
        if (it.properties) o.properties = it.properties;
        return o;
      });
      return request('cart/add.js', { items: list }).then(function (added) {
        return request('cart.js').then(function (c) {
          publish(c, 'add');
          emit('oc:cart-added', { items: added.items || [added], cart: c });
          return { added: added, cart: c };
        });
      }).catch(function (e) { return fail(e, 'add'); });
    },
    /** POST /cart/change.js. o: {line (1-based) | id (line item key), quantity, selling_plan?}.
        selling_plan: null removes the plan from the line. */
    change: function (o) { return request('cart/change.js', o).then(function (c) { return publish(c, 'change'); }).catch(function (e) { return fail(e, 'change'); }); },
    /** POST /cart/update.js. updates: {variantIdOrKey: qty} or array of quantities. */
    update: function (updates, extra) {
      var body = { updates: updates };
      if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) body[k] = extra[k];
      return request('cart/update.js', body).then(function (c) { return publish(c, 'update'); }).catch(function (e) { return fail(e, 'update'); });
    },
    setCount: setCount
  };

  /* ---------- dialogs and drawers (native <dialog>) ---------- */
  function dur3() { return reducedMotion() ? 0 : 320; }
  function openDialog(dlg, opener) {
    if (typeof dlg === 'string') dlg = d.getElementById(dlg);
    if (!dlg || dlg.open) return;
    dlg._ocOpener = opener || d.activeElement;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    lock();
    $$('[data-oc-open="' + dlg.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-open'); }); });
    emit('oc:dialog-open', { id: dlg.id, dialog: dlg }, dlg);
  }
  function finishClose(dlg) {
    if (dlg.open) { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
  }
  function closeDialog(dlg) {
    if (typeof dlg === 'string') dlg = d.getElementById(dlg);
    if (!dlg || !dlg.open || dlg._ocClosing) return;
    dlg._ocClosing = true;
    dlg.classList.remove('is-open');
    var ms = dur3();
    if (ms) setTimeout(function () { finishClose(dlg); }, ms); else finishClose(dlg);
  }
  function onDialogClosed(dlg) {
    dlg._ocClosing = false;
    dlg.classList.remove('is-open');
    unlock();
    $$('[data-oc-open="' + dlg.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var o = dlg._ocOpener;
    if (o && typeof o.focus === 'function' && d.contains(o)) { try { o.focus({ preventScroll: true }); } catch (e) { o.focus(); } }
    emit('oc:dialog-close', { id: dlg.id, dialog: dlg }, dlg);
  }
  function wireDialog(dlg) {
    if (dlg._ocWired) return;
    dlg._ocWired = true;
    dlg.addEventListener('close', function () { onDialogClosed(dlg); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeDialog(dlg); });
    dlg.addEventListener('click', function (e) {
      if (e.target !== dlg) return;               // clicks on content bubble from children
      var r = dlg.getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside || dlg.hasAttribute('data-oc-backdrop-close')) closeDialog(dlg);
    });
  }

  /* ---------- a11y helpers ---------- */
  var liveRegion;
  function announce(msg, politeness) {
    if (!liveRegion) {
      liveRegion = d.createElement('div');
      liveRegion.id = 'oc-live';
      liveRegion.className = 'oc-vh';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('role', 'status');
      d.body.appendChild(liveRegion);
    }
    liveRegion.setAttribute('aria-live', politeness === 'assertive' ? 'assertive' : 'polite');
    liveRegion.textContent = '';
    setTimeout(function () { liveRegion.textContent = msg; }, 60);
  }
  /** Busy state for a submit button: aria-busy, blocks double submit, swaps .oc-btn__label text. */
  function busy(btn, isBusy, label) {
    if (!btn) return;
    var lab = btn.querySelector('.oc-btn__label');
    if (isBusy) {
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('aria-disabled', 'true');
      if (lab) { btn._ocLabel = lab.textContent; lab.textContent = label || I18N.adding || 'Adding…'; }
    } else {
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('aria-disabled');
      if (lab && btn._ocLabel != null) { lab.textContent = btn._ocLabel; btn._ocLabel = null; }
    }
  }
  /* Mirror :has() states on .oc-choice for browsers without :has() (Safari < 15.4, Firefox ESR 115):
     .is-checked / .is-disabled here; .is-focus from the focus listeners below (keyboard focus only). */
  function syncChoices(scope) {
    $$('.oc-choice__input', scope).forEach(function (inp) {
      var card = inp.closest('.oc-choice');
      if (!card) return;
      card.classList.toggle('is-checked', inp.checked);
      card.classList.toggle('is-disabled', inp.disabled);
    });
  }

  /* ---------- analytics (no custom pixel; Shopify's own bus only, BRIEF §7) ---------- */
  function track(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data || {});
      }
    } catch (e) { /* never break the page for analytics */ }
  }

  /* ---------- scroll helpers (Horizon makes .page-wrapper the scroller at ≥990px) ---------- */
  var mqSqueeze = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  var scroll = {
    container: function () {
      var pw = $('.page-wrapper');
      if (mqSqueeze && mqSqueeze.matches && pw && pw.scrollHeight > pw.clientHeight) return pw;
      return d.scrollingElement || de;
    },
    top: function () { return scroll.container().scrollTop; },
    to: function (el, opts) {
      if (typeof el === 'string') el = $(el);
      if (!el) return;
      el.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: (opts && opts.block) || 'start' });
    }
  };

  /* ---------- sticky-bar helpers (COMMERCE's oc-sticky uses these) ---------- */
  // Shopify's own consent banner ids (UNVERIFIED: test in preview) + generic fixed consent banners (apps).
  var CONSENT_SEL = '#shopify-pc__banner, #shopify-pc__prefs, .shopify-pc__banner__dialog, [id^="shopify-pc__banner"]';
  var CONSENT_GENERIC = '[id*="consent" i], [class*="consent-banner" i]';
  function visible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }
  function consentVisible() {
    if ($$(CONSENT_SEL).some(visible)) return true;
    var list;
    try { list = $$(CONSENT_GENERIC); } catch (e) { return false; } // the "i" flag is unsupported in very old engines
    return list.some(function (el) {
      if (el.closest && el.closest('[data-oc-sticky]')) return false;
      var pos = window.getComputedStyle(el).position;
      return (pos === 'fixed' || pos === 'sticky') && visible(el);
    });
  }
  var padNow = null;
  var sticky = {
    /** Calls cb(true) once `target` has scrolled ABOVE the viewport, cb(false) when it is back or below. */
    watch: function (target, cb) {
      if (!target || !('IntersectionObserver' in window)) return function () {};
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { cb(!en.isIntersecting && en.boundingClientRect.top < 0, en); });
      }, { threshold: 0 });
      io.observe(target);
      return function () { io.disconnect(); };
    },
    /** Calls cb(true) while any of `targets` (elements or a selector) is in view (final CTA, footer). */
    watchInView: function (targets, cb) {
      var els;
      try { els = typeof targets === 'string' ? $$(targets) : [].concat(targets).filter(Boolean); } catch (e) { els = []; }
      if (!els.length || !('IntersectionObserver' in window)) return function () {};
      var seen = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) seen.add(en.target); else seen.delete(en.target); });
        cb(seen.size > 0);
      }, { threshold: 0 });
      els.forEach(function (el) { io.observe(el); });
      return function () { io.disconnect(); };
    },
    /** True while a dialog/drawer is open, a text field has focus (keyboard up) or a consent banner shows. */
    blocked: function () {
      if ($('dialog[open]')) return true;
      var a = d.activeElement;
      if (a && (a.tagName === 'TEXTAREA' || a.tagName === 'SELECT' || (a.tagName === 'INPUT' && !/^(radio|checkbox|button|submit|hidden)$/i.test(a.type)))) return true;
      return consentVisible();
    },
    /** Calls cb(blocked) whenever a blocker may have changed. A consent banner can animate in without any DOM change,
        so it is also polled, but only while isActive() says the bar could show (phones, past the trigger), and never
        again once a banner has been seen and dismissed. Returns off(); off.arm() restarts polling when the caller's
        state may have become active. */
    watchBlockers: function (cb, isActive) {
      var fire = function () { cb(sticky.blocked()); };
      var offs = [on('oc:dialog-open', fire), on('oc:dialog-close', fire), on('focusin', fire), on('focusout', function () { setTimeout(fire, 0); })];
      var mo = new MutationObserver(function () { fire(); });
      mo.observe(d.body, { childList: true, subtree: false, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      var t = null, seenBanner = false, done = false;
      function stop() { if (t) { clearInterval(t); t = null; } }
      function tick() {
        if (done || (isActive && !isActive())) { stop(); return; }
        if (consentVisible()) seenBanner = true; else if (seenBanner) done = true; // dismissed: stop polling for good
        fire();
      }
      function arm() { if (!t && !done && (!isActive || isActive())) t = setInterval(tick, 1500); }
      fire();
      arm();
      var off = function () { offs.forEach(function (f) { f(); }); mo.disconnect(); stop(); done = true; };
      off.arm = arm;
      return off;
    },
    /** Reserve space under the page for a fixed bottom bar (px, 0 to clear). Writes only on change (no layout churn). */
    pad: function (px) {
      var v = Math.max(0, Math.ceil(Number(px) || 0));
      if (v === padNow) return;
      padNow = v;
      de.style.setProperty('--oc-sticky-pad', v + 'px');
    }
  };

  /* ---------- header: border after scroll, cart count ---------- */
  function initHeader() {
    var header = $('[data-oc-header]');
    var main = $('#MainContent') || $('main');
    if (header && main && 'IntersectionObserver' in window) {
      var sentinel = d.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:relative;height:1px;margin-bottom:-1px;pointer-events:none';
      main.insertBefore(sentinel, main.firstChild);
      new IntersectionObserver(function (en) {
        // rootMargin -8px: the line appears after 8 px of scroll. Compare with rootBounds, not 0, because
        // smooth scrolling (Horizon sets scroll-behavior) can report the crossing at top = 0…7.
        var e0 = en[0];
        var edge = e0.rootBounds ? e0.rootBounds.top : 8;
        var scrolled = !e0.isIntersecting && e0.boundingClientRect.top < edge;
        header.classList.toggle('is-scrolled', scrolled);
        emit('oc:header-scrolled', { scrolled: scrolled });
      }, { rootMargin: '-8px 0px 0px 0px' }).observe(sentinel);
    }
    setCount(cart.count);
    // Keep the badge right after bfcache restores and after Horizon's own cart actions.
    window.addEventListener('pageshow', function (e) { if (e.persisted) cart.get().catch(function () {}); });
    // Horizon 4.2 announces its own cart changes as Shopify standard events (assets/standard-events.d.ts).
    d.addEventListener('shopify:cart:lines-update', function (e) {
      if (e && e.detail && e.detail.source === 'oc') return;
      cart.get().catch(function () {});
    });
  }

  /* ---------- reveal (below-the-fold [data-oc-reveal] only; content is never hidden without JS) ---------- */
  function initReveal() {
    if (reducedMotion() || !('IntersectionObserver' in window)) return;
    var vh = window.innerHeight || de.clientHeight;
    var items = $$('[data-oc-reveal]').filter(function (el) { return el.getBoundingClientRect().top > vh; });
    if (!items.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { el.classList.add('oc-reveal-ready'); io.observe(el); });
  }

  /* ---------- delegated clicks ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var opener = t.closest('[data-oc-open]');
    if (opener) {
      var dlg = d.getElementById(opener.getAttribute('data-oc-open'));
      if (dlg && dlg.tagName === 'DIALOG') { e.preventDefault(); wireDialog(dlg); openDialog(dlg, opener); }
      return;
    }
    var closer = t.closest('[data-oc-close]');
    if (closer) { e.preventDefault(); closeDialog(closer.closest('dialog')); return; }
    // A same-page anchor inside an open drawer: close the drawer, then scroll.
    var a = t.closest('dialog[open] a[href*="#"]');
    if (a && a.pathname === location.pathname && a.hash && d.getElementById(a.hash.slice(1))) {
      closeDialog(a.closest('dialog'));
    }
  });
  d.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('oc-choice__input')) {
      var form = t.form || t.closest('form') || d;
      syncChoices(form);
    }
  });
  // .is-focus on the card whose (invisible) radio has keyboard focus, like :focus-visible (no ring on mouse/touch)
  var kbd = false;
  d.addEventListener('keydown', function (e) { if (!e.metaKey && !e.ctrlKey && !e.altKey) kbd = true; }, true);
  d.addEventListener('pointerdown', function () { kbd = false; }, true);
  d.addEventListener('mousedown', function () { kbd = false; }, true);
  d.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('oc-choice__input')) return;
    var card = t.closest('.oc-choice');
    var fv = kbd;
    try { fv = t.matches(':focus-visible'); } catch (x) { /* no :focus-visible: keyboard flag */ }
    if (card) card.classList.toggle('is-focus', !!fv);
  });
  d.addEventListener('focusout', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('oc-choice__input')) {
      var card = t.closest('.oc-choice');
      if (card) card.classList.remove('is-focus');
    }
  });

  /* ---------- public API ---------- */
  var OC = {
    version: '1.1.0',
    cfg: CFG,
    ready: function (fn) { if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { fn(OC); }); else fn(OC); },
    on: on,
    emit: emit,
    money: money,
    fmt: fmt,
    cart: cart,
    dialog: { open: function (dlg, opener) { if (typeof dlg === 'string') dlg = d.getElementById(dlg); if (dlg) { wireDialog(dlg); openDialog(dlg, opener); } }, close: closeDialog },
    lock: lock,
    unlock: unlock,
    a11y: { announce: announce, busy: busy, syncChoices: syncChoices },
    track: track,
    sticky: sticky,
    scroll: scroll,
    reducedMotion: reducedMotion
  };
  window.OC = OC;

  OC.ready(function () {
    $$('dialog.oc-dialog, dialog.oc-drawer').forEach(wireDialog);
    syncChoices(d);
    initHeader();
    initReveal();
    var q = window.OCQ || [];
    window.OCQ = { push: function (fn) { try { fn(OC); } catch (e) { setTimeout(function () { throw e; }); } } };
    q.forEach(function (fn) { window.OCQ.push(fn); });
  });
})();
